// removed by extract-text-webpack-plugin
module.exports = {"setupform-vouchers-form":"_1e40_IOA- _2l0xl0HVf","select":"_1UsjtDyM- JmRuDZRyu y4wLu1mD3 vUrsJl1Yt _19QZFK_l1 _1NlI_spEh _1EdaqRqa1 _2OFXNnC9U _2WNDOuoxI"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/setupform-vouchers-form/setupform-vouchers-form.css
 ** module id = 2172
 ** module chunks = 0
 **/